export default __webpack_public_path__ + "4463f3bfa2aca632d2602107375c1f6e.png";